import { useEffect, useState } from "react";

import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import { useAppDispatch, useAppSelector } from "@app/store";
import {
  setProducts,
  useDeleteProductMutation,
  useLazyGetProductsQuery,
  useReorderProductsMutation
} from "@modules/product";
import Table from '@mui/material/Table';
import { FilterParams } from "types";
import { PARAMS } from "@constants/index";
// eslint-disable-next-line no-restricted-imports
import { IProduct } from "@modules/product/types";

import { StyledBody, TitleWrapper, EachWrapper, Actions, Wrapper } from "./styled";

interface StateItems extends Omit<IProduct, 'id'> {
  id: number;
}

const Products = () => {
  const productsList = useAppSelector((state) => state.product.products);

  const [state, setState] = useState<StateItems[]>([]);
  const dispatch = useAppDispatch();
  const [getProducts] = useLazyGetProductsQuery()
  const [deleteProduct] = useDeleteProductMutation()
  const [updateSorting] = useReorderProductsMutation()

  const [pagesCount, setPagesCount] = useState<number>(1);
  const [allow, setAllow] = useState(false);
  const [filters, setFilters] = useState<FilterParams>({
    limit: PARAMS.LIMIT,
    offset: PARAMS.OFFSET,
  })

  const handleGetRequest = async () => {
    try {
      const responseProducts = await getProducts(filters).unwrap();

      dispatch(setProducts(responseProducts.products));
      setPagesCount(responseProducts.count || 1)
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteProduct = async (id?: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteProduct({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleGetRequest()
  }, [filters])

  useEffect(() => {
    if (productsList.length) {
      setState(productsList.map((item, index) => ({
        ...item,
        idd: item.id,
        id: index + 1
      })))
    }
  }, [productsList])

  useEffect(() => {
    if (allow && state?.length) {
      const prepareAndRequest = async () => {
        const ordered = state?.map((item, index) => ({
          sort: index + 1,
          id: item.idd
        }))

        await updateSorting(ordered)
        setAllow(false)
      }

      prepareAndRequest()
    }
  }, [state, allow])

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <Link to={PRIVATE_PAGES.CREATE_PRODUCTS}>
        <Button variant="contained" color="primary">
          Create Product
        </Button>
      </Link>

      <Wrapper>
        <Table>
          <TitleWrapper>
            <div>Brand</div>
            <div>
              Image
            </div>
            <div>TITLE AM</div>
            <div>TITLE En</div>
            <div>TITLE Ru</div>
            <div>ACTIONS</div>
          </TitleWrapper>
          <StyledBody
            list={state}
            setList={setState}
            onEnd={() => {
              setAllow(true)
            }}
          >
            {state?.map((product) => {
              const image = product?.images?.[0]?.url || ''

              return (
                <EachWrapper key={product.id}>
                  <div>{product.brand.toUpperCase()}</div>
                  <div>
                    { image
                      ? (
                        <img
                          width="80px"
                          src={`${process.env.REACT_APP_API_BASE_URL}/${image}`}
                          alt={product.titleAm}
                        />
                      )
                      : null}
                  </div>
                  <div>{product.titleAm}</div>
                  <div>{product.titleEn}</div>
                  <div>{product.titleRu}</div>
                  <Actions>
                    <Link to={`/update-product/${product?.idd}`}>
                      <Button
                        variant="outlined"
                      >
                        Edit
                      </Button>
                    </Link>
                    <Button
                      variant="contained"
                      onClick={() => handleDeleteProduct(product?.idd)}
                    >
                      Delete
                    </Button>
                  </Actions>
                </EachWrapper>
              )
            })}
          </StyledBody>
        </Table>
      </Wrapper>
    </Box>
  )
};

export default Products;
